'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HotelSearchPage = exports.mapDispatchToProps = exports.asyncProps = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _class, _temp;
// if bindActionCreators is needed, uncomment this line
// import {bindActionCreators} from 'redux';

// api

// containers


// components


// action creators


exports.mapStateToProps = mapStateToProps;
exports.applyFilters = applyFilters;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _reduxConnect = require('redux-connect');

var _trvFedApiClient = require('../trv-fed-api-client.js');

var _trvFedApiClient2 = _interopRequireDefault(_trvFedApiClient);

var _HotelSearchBox = require('./HotelSearchBox');

var _HotelSearchBox2 = _interopRequireDefault(_HotelSearchBox);

var _BreadCrumb = require('../components/BreadCrumb');

var _BreadCrumb2 = _interopRequireDefault(_BreadCrumb);

var _Filters = require('../components/Filters');

var _Filters2 = _interopRequireDefault(_Filters);

var _Paging = require('../components/Paging');

var _Paging2 = _interopRequireDefault(_Paging);

var _Sort = require('../components/Sort');

var _Sort2 = _interopRequireDefault(_Sort);

var _Count = require('../components/Count');

var _Count2 = _interopRequireDefault(_Count);

var _HotelList = require('../components/HotelList');

var _HotelList2 = _interopRequireDefault(_HotelList);

var _HotelError = require('../components/HotelError');

var _HotelError2 = _interopRequireDefault(_HotelError);

var _GoogleMapPointPicker = require('../components/GoogleMapPointPicker');

var _GoogleMapPointPicker2 = _interopRequireDefault(_GoogleMapPointPicker);

var _MapModal = require('../components/MapModal');

var _MapModal2 = _interopRequireDefault(_MapModal);

var _Navigations = require('../components/Navigations');

var _Navigations2 = _interopRequireDefault(_Navigations);

var _filters = require('../helpers/filters');

var _query = require('../helpers/query');

var _breadcrumbs = require('../modules/breadcrumbs');

var _search = require('../modules/search');

var _hotels = require('../modules/hotels');

var _navigations = require('../modules/navigations');

var _filters2 = require('../modules/filters');

var _exception = require('../modules/exception');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://github.com/makeomatic/redux-connect/blob/master/docs/API.MD
var asyncProps = exports.asyncProps = [{
  promise: function preload(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        location = _ref.location,
        params = _ref.params;

    var state = getState();
    var promises = [];
    var urls = state.urls,
        breadcrumbs = state.breadcrumbs,
        navigations = state.navigations;

    // TODO: make it stateless and always get breadcrumbs and navigations for now
    //       after refactor the reducers, we should find a better way to prevent fetching breadcrumbs every time

    var ids = (0, _query.getIds)(params);
    if (!breadcrumbs.items.length || breadcrumbs.ids !== ids) {
      var types = ['country', 'subdivision', 'city', 'spot'].slice(0, (0, _keys2.default)(params).length).join(',');
      promises.push((0, _trvFedApiClient2.default)(urls.api.breadcrumbs, 'GET', { ids: ids, types: types, category: 'multilingual' }, state.httpRequest.req, {
        maintenance: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater },
        timeout: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater }
      }, 3000).then(function (res) {
        return dispatch((0, _breadcrumbs.set)((0, _extends3.default)({ ids: ids }, res)));
      }, function (res) {
        dispatch((0, _breadcrumbs.clear)());
        dispatch((0, _exception.throwException)(res.errors));
      }));
    }

    if (navigations.ids !== ids) {
      promises.push((0, _trvFedApiClient2.default)(urls.api.navigations, 'GET', {
        country: params.countryID.replace(/_/g, ' '),
        subdivision: params.subdivisionID.replace(/_/g, ' ')
        // TODO: After API has been change to accept " Prefecture", remove logic below.
        .replace(' Prefecture', '_Prefecture'),
        city: params.cityID ? params.cityID.replace(/_/g, ' ') : undefined
      }, state.httpRequest.req, {
        maintenance: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater },
        timeout: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater }
      }, 2000).then(function (res) {
        return dispatch((0, _navigations.set)((0, _extends3.default)({ ids: ids }, res)));
      }, function (res) {
        // Should not throw exception
        // Even if error has been occurred, service should be available
        console.error(res);
        dispatch((0, _navigations.clear)());
      }));
    }

    var locationQuery = (0, _query.convertLocationToState)(location.query, params).search;
    // Compare query and search state, if there is any difference, fetch hotels
    // TODO: Get rid of errors from query
    // XXX: When user comes from hotel information page, need to fetch. Currently there is no way to detect it.
    //      in order to prevent further bugs due to the statefull nature, always update the hotels state
    var query = (0, _extends3.default)({}, state.search, locationQuery);
    dispatch((0, _search.set)(locationQuery));
    dispatch((0, _filters2.setFilters)((0, _filters.convertToStates)(state.filters.filters, locationQuery)));
    if (location.query.price) {
      dispatch((0, _filters2.setPriceRange)((0, _filters.parsePrice)(location.query.price)));
    } else {
      dispatch((0, _filters2.clearPriceRange)());
      dispatch((0, _search.clearPrice)());
    }
    promises.push((0, _trvFedApiClient2.default)(urls.api.hotels, 'GET', query, state.httpRequest.req, {
      maintenance: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater },
      timeout: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater }
    }, 8000).then(function (res) {
      dispatch((0, _hotels.set)(res));
      dispatch((0, _filters2.setFilters)((0, _filters.convertToStates)(res.filters, locationQuery)));
      dispatch((0, _filters2.setPriceRange)(res.priceRange));
    },
    // TODO: display error result
    function (res) {
      dispatch((0, _hotels.clear)());
      if (_lodash2.default.find(res.errors, { code: 'VALIDATION_ERROR' })) {
        dispatch((0, _search.setErrors)(res.errors));
      } else {
        dispatch((0, _exception.throwException)(res.errors));
      }
    }));

    return _promise2.default.all(promises);
  }
}];

// mapStateToprops can be either an object or a funciton
function mapStateToProps(state, ownProps) {
  var breadcrumbs = _lodash2.default.cloneDeep(state.breadcrumbs.items);
  var currentArea = breadcrumbs.length ? breadcrumbs.pop().text : '';

  return {
    i18n: state.i18n,
    location: ownProps.location,
    breadcrumbs: state.breadcrumbs.items,
    hotels: state.hotels,
    navigations: state.navigations,
    search: state.search,
    filters: state.filters.filters,
    priceRange: state.filters.priceRange,
    req: state.httpRequest.req,
    currentArea: currentArea
  };
}

// mapDispatchToprops can be either an object or a funciton
var mapDispatchToProps = exports.mapDispatchToProps = {
  push: _reactRouterRedux.push,
  setPriceRange: _filters2.setPriceRange
};
// TODO: this function is duplicated in HotelInformationPage
function applyFilters(submitted, props) {
  var search = props.search,
      location = props.location,
      push = props.push,
      setPriceRange = props.setPriceRange;

  var values = (0, _extends3.default)({}, search, (0, _filters.convertToParams)({
    filters: submitted.filters,
    priceRange: submitted.priceRange
  }), {
    offset: 0
  });
  setPriceRange(submitted.priceRange);
  push({
    pathname: location.pathname,
    query: (0, _query.convertStateToLocationQuery)({ search: values })
  });
}

var HotelSearchPage = exports.HotelSearchPage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HotelSearchPage, _Component);

  function HotelSearchPage(props) {
    (0, _classCallCheck3.default)(this, HotelSearchPage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HotelSearchPage.__proto__ || (0, _getPrototypeOf2.default)(HotelSearchPage)).call(this, props));

    _this.state = {
      height: 600,
      isMapOpen: false
    };
    _this.closeMap = _this.closeMap.bind(_this);
    return _this;
  }

  // checking element position is only available after the component is rendered
  /* eslint react/no-did-mount-set-state: "off" */


  (0, _createClass3.default)(HotelSearchPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.mapSide) {
        // XXX: set the height of 'hotel-side' to fix the position of the map when scrolling the hotel list
        var rect = this.mapSide.getBoundingClientRect();
        this.setState({ height: window.innerHeight - rect.top });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // XXX: on page change, need to scroll to top
      if (nextProps.search.offset !== this.props.search.offset) {
        this.hotelSide.scrollTop = this.filters.clientHeight;
        window.scroll(0, 0);
      }
    }
  }, {
    key: 'openMap',
    value: function openMap(e) {
      e.preventDefault();
      this.setState({ isMapOpen: true });
    }
  }, {
    key: 'closeMap',
    value: function closeMap() {
      this.setState({ isMapOpen: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          i18n = _props.i18n,
          location = _props.location,
          breadcrumbs = _props.breadcrumbs,
          hotels = _props.hotels,
          navigations = _props.navigations,
          search = _props.search,
          filters = _props.filters,
          priceRange = _props.priceRange,
          push = _props.push,
          setPriceRange = _props.setPriceRange,
          currentArea = _props.currentArea;
      var isMapOpen = this.state.isMapOpen;


      return _react2.default.createElement(
        'div',
        { className: 'area-layout02 area-layout-hero layout-fluid' },
        _react2.default.createElement(
          'div',
          { className: 'full-width-box hotel-list-search' },
          _react2.default.createElement(
            'div',
            { className: 'fluid-searchform' },
            _react2.default.createElement(_HotelSearchBox2.default, {
              hideDetails: true
            })
          )
        ),
        _react2.default.createElement(_BreadCrumb2.default, { items: breadcrumbs, location: location }),
        (!hotels.items || !hotels.items.length) && !_lodash2.default.find(filters, { checked: true }) && !priceRange.low && !priceRange.high ? _react2.default.createElement(_HotelError2.default, {
          title: i18n.errors.roomCouldNotFind,
          message: i18n.errors.pleaseSearchAgain
        }) : _react2.default.createElement(
          'div',
          { className: 'hotel-list-and-map' },
          _react2.default.createElement(
            'div',
            {
              ref: function ref(node) {
                _this2.hotelSide = node;
              },
              className: 'hotel-side',
              style: { height: this.state.height }
            },
            _react2.default.createElement(_Filters2.default
            // XXX: need to get the native DOM for scroll position
            // eslint-disable-next-line
            , { ref: function ref(node) {
                _this2.filters = _reactDom2.default.findDOMNode(node);
              },
              i18n: i18n,
              search: search,
              isDisplayCount: true,
              min: +priceRange.min,
              max: +priceRange.max,
              low: +priceRange.low,
              high: +priceRange.high,
              filters: filters,
              onSubmit: function onSubmit(submitted) {
                applyFilters(submitted, { search: search, location: location, push: push, setPriceRange: setPriceRange });
              }
            }),
            hotels.items && hotels.items.length ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'hotel-list-header' },
                _react2.default.createElement(_Count2.default, { i18n: i18n, offset: +hotels.offset, limit: +hotels.limit, total: +hotels.total }),
                _react2.default.createElement(_Sort2.default, {
                  i18n: i18n,
                  defaultOption: search.orderBy,
                  onChange: function onChange(value) {
                    push({
                      pathname: location.pathname,
                      query: (0, _extends3.default)({}, location.query, {
                        orderBy: value,
                        offset: 0
                      })
                    });
                  }
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'hotel-list-box' },
                _react2.default.createElement(_HotelList2.default, { i18n: i18n, items: hotels.items, location: location, search: search })
              ),
              _react2.default.createElement(
                'div',
                { className: 'hotel-list-footer' },
                _react2.default.createElement(_Count2.default, { i18n: i18n, offset: +hotels.offset, limit: +hotels.limit, total: +hotels.total }),
                _react2.default.createElement(_Paging2.default, { i18n: i18n, location: location, offset: +hotels.offset, limit: +hotels.limit, total: +hotels.total }),
                _react2.default.createElement(
                  'div',
                  { className: 'mobile-map-box' },
                  _react2.default.createElement(
                    'a',
                    { href: true, onClick: function onClick(e) {
                        return _this2.openMap(e);
                      } },
                    i18n.hotelSearch.map,
                    _react2.default.createElement('span', { className: 'icon-hotel-address' })
                  )
                )
              )
            ) : _react2.default.createElement(_HotelError2.default, {
              title: i18n.errors.hotelCouldNotFind,
              message: i18n.errors.pleaseRefreshAdditionalConditions
            })
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'map-side',
              ref: function ref(node) {
                _this2.mapSide = node;
              },
              style: { height: this.state.height }
            },
            _react2.default.createElement(
              'div',
              { className: 'map-side-sub', style: { height: '100%' } },
              _react2.default.createElement(
                'div',
                { id: 'result-map-box' },
                _react2.default.createElement(
                  'div',
                  { id: 'result-map', style: { height: '100%' } },
                  _react2.default.createElement(_GoogleMapPointPicker2.default, {
                    center: hotels.items && hotels.items.length && hotels.items[0].latlng ? hotels.items[0].latlng.split(',').map(function (str) {
                      return Number(str);
                    }) : undefined,
                    i18n: i18n,
                    location: location,
                    search: search,
                    hoverId: hotels.hoverId,
                    places: hotels.items.map(function (item) {
                      return (0, _extends3.default)({}, item, {
                        id: String(item.id),
                        lat: Number(item.latlng.split(',')[0]),
                        lng: Number(item.latlng.split(',')[1])
                      });
                    })
                  })
                )
              )
            )
          )
        ),
        navigations.spotTypes && navigations.spotTypes.length ? _react2.default.createElement(_Navigations2.default, { i18n: i18n, title: i18n.hotelSearch.popularPlaces.replace('{place}', currentArea), items: navigations.spotTypes, location: location }) : null,
        navigations.cities && navigations.cities.length ? _react2.default.createElement(_Navigations2.default, { i18n: i18n, title: i18n.hotelSearch.otherCitiesInTheSameArea.replace('{place}', currentArea), items: navigations.cities, location: location }) : null,
        navigations.subdivisions && navigations.subdivisions.length ? _react2.default.createElement(_Navigations2.default, { i18n: i18n, title: i18n.hotelSearch.otherAreasInTheSameCountry.replace('{place}', currentArea), items: navigations.subdivisions, location: location }) : null,
        hotels.items && hotels.items.length ? _react2.default.createElement(
          _MapModal2.default,
          {
            isMapOpen: isMapOpen,
            closeMap: this.closeMap,
            mapTitle: currentArea
          },
          _react2.default.createElement(_GoogleMapPointPicker2.default, {
            i18n: i18n,
            location: location,
            search: search,
            center: hotels.items[0].latlng ? hotels.items[0].latlng.split(',').map(function (str) {
              return Number(str);
            }) : undefined,
            places: hotels.items.map(function (item) {
              return (0, _extends3.default)({}, item, {
                id: String(item.id),
                lat: Number(item.latlng.split(',')[0]),
                lng: Number(item.latlng.split(',')[1])
              });
            })
          })
        ) : null,
        _react2.default.createElement(_BreadCrumb2.default, { id: 'subfooter', items: breadcrumbs, location: location })
      );
    }
  }]);
  return HotelSearchPage;
}(_react.Component), _class.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  location: _react.PropTypes.object.isRequired,
  breadcrumbs: _react.PropTypes.array.isRequired,
  hotels: _react.PropTypes.object.isRequired,
  navigations: _react.PropTypes.object.isRequired,
  search: _react.PropTypes.object.isRequired,
  filters: _react.PropTypes.array.isRequired,
  priceRange: _react.PropTypes.object.isRequired,
  push: _react.PropTypes.func.isRequired,
  setPriceRange: _react.PropTypes.func.isRequired,
  currentArea: _react.PropTypes.string
}, _class.defaultProps = {
  hotels: { items: [] }
}, _temp);


var asyncConnectedHotelSearch = (0, _reduxConnect.asyncConnect)(asyncProps)(HotelSearchPage);

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(asyncConnectedHotelSearch);


//////////////////
// WEBPACK FOOTER
// ./src/containers/HotelSearchPage.js
// module id = 1237
// module chunks = 0